module.exports = __webpack_public_path__ + "img/507.99d0bf97.png";